import { lighten } from '@mui/material';
import { palette } from '../palette';
import lightOrdarkColor from "@check-light-or-dark/color";

const MuiButton = {
  defaultProps: {
    size: 'large',
    color: 'primary',
    fontFamily: 'Open sans',
  },
  styleOverrides: {
    root: ({theme} : any) => ({
      textWrap: 'nowrap',
      padding: "9px 16px",
      gap: "8px",
      borderRadius: "8px",
      alignItems: "center",
      fontStyle: "SemiBold",
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '5%',
      fontSize: '1rem',
      boxShadow: 'none',
      minWidth:'auto',
      '&.Mui-disabled': {
        borderColor:  lightOrdarkColor(theme.palette.background.default) === 'dark' ?  palette.disabledColor.dark : palette.disabledColor.light,
        backgroundColor: lightOrdarkColor(theme.palette.background.default) === 'dark' ?  palette.disabledColor.dark : palette.disabledColor.light,
        color: palette.disabledColor.contrastText,
      },
    }),

    startIcon: {
      marginRight: 0,
      marginLeft: 0,
    },

    iconSizeMedium: {
      marginBottom: '1px',
    },

    outlined : ({theme} : any) => ({
      '&:hover': { backgroundColor: lighten(theme.palette.primary.light,0.5) },
     }),

    contained: ({theme} : any) => ({
        color: lighten(theme.palette.background.default,0.9),
        '&:hover': { backgroundColor: lighten(theme.palette.primary.light,0.5), color: theme.palette.primary.main },
    }),

    containedPrimary: {
      '& path': {
        transition:
          'all 250mi s cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
      '&:hover': {
        boxShadow: 'none',
      },
    },

    outlinedSuccess: {
      borderColor: palette.success.dark,
      color: palette.success.dark,
      '&:hover': {
        backgroundColor: palette.success.light,
      },
    },

    containedSuccess: {
      backgroundColor: palette.success.dark,
      color: palette.success.light,
      '&:hover': {
        backgroundColor : palette.success.light,
        color: palette.success.dark,
        boxShadow: 'none',
      },
    },

    outlinedError:{
      borderColor: `${palette.error.main} !important`,
      color: palette.error.main,
      '&:hover': {
        backgroundColor: palette.error.light,
      },
    },

    containedError: {
      backgroundColor: palette.error.main,
      color: palette.error.light,
      '&:hover': {
        backgroundColor : palette.error.light,
        color: palette.error.main,
        boxShadow: 'none',
      },
    },

        

    outlinedInfo: {
      '&:hover': {
        backgroundColor: palette.info.light,
        borderColor: palette.info.light,
      },
    },

    containedInfo: {
      '&:hover': {
        color: palette.info.main,
        boxShadow: 'none',
      },
    },

    sizeSmall: {
      width: '102px',
    },

    sizeMedium: {
      width: '134px',
      padding: '9px 16px',
    },
  },
};

export default MuiButton;
